import * as yup from 'yup';
import { yupUtils } from '../../utils/yup/utils';
import { Network } from '../types/network';
import { ProjectErrors, ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorForCode, isProjectError } from '../../utils/errors';

export const MinimalNetworkSchema = yup.object().shape({
  name: yupUtils.stringRequired('Name is a required field'),
  networkId: yupUtils.stringRequired('Network ID is a required field'),
});

export const parseNetwork = async (object: any): Promise<Network | ProjectErrorType> => {
  try {
    // Validate that required fields exist
    if (object && object.id && object.name && object.networkId) {
      const network: Network = {
        id: object.id,
        name: object.name,
        networkId: object.networkId,
      };
      return network;
    }
    console.log(`[NETWORKS] Invalid network object - missing fields`);
    return getProjectErrorForCode(ProjectErrors.invalidNetwork);
  } catch (error) {
    console.log(`[NETWORKS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorForCode(ProjectErrors.invalidNetwork);
  }
};

export const parseNetworks = async (items: any): Promise<Network[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[NETWORKS] Error: No array found.');
    return [];
  }

  const data: Network[] = [];
  for (const item of items) {
    const o = await parseNetwork(item);
    if (o && !isProjectError(o)) {
      data.push(o as Network);
    }
  }

  return data;
};
